import { SolicitudValida } from './../../models/request/solicitud-valida';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../../http/http.service';
import { GeneralResponse } from '../../models/general-response/general-response';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { RequestsResponse } from '../../models/disaffiliation/requests-response';

@Injectable({
  providedIn: 'root'
})
export class DisaffiliationService {

  constructor(private _http: HttpService) { }

  getData(params: any): Observable<RequestsResponse> {
    return this._http.get<RequestsResponse>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      '/request/filter',
      params
    ).pipe(map((response => response)));
  }

  getExcelAffiliationMas(filedNumber: string,fecha:string): Observable<string> {
    const params = {
      numeroRadicado: filedNumber,
      fechaRetiro: fecha
    };

    return this._http.get<GeneralResponse<string>>(
      environment.DESAFILIACION_MASIVA.PREFIJO_URL,
      '/disaffiliate-massive/get-disaffiliations/excel',
      params
    ).pipe(map((response => response.body)));
  }

  getDataRequestValid(params: any): Observable<SolicitudValida> {
    return this._http.get<SolicitudValida>(
      environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL,
      '/request/valid',
      params
    ).pipe(map((response => response)));
  }

}
